import * as React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
//import { AppBar } from '@mui/material'
//import Tabs from '@mui/material/Tabs';
//import Tab from '@mui/material/Tab';

// const MenuFooter = () => <Tabs
//   value={0}
//   //onChange={handleChange}
//   variant="scrollable"
//   scrollButtons
//   allowScrollButtonsMobile
//   aria-label="scrollable force tabs example"
// >
//   <Tab label="Convênio" />
//   <Tab label="Plano" />
//   <Tab label="Especialidade" />
//   <Tab label="Dia" />
//   <Tab label="Profissional" />
// </Tabs>

function Copyright() {
  const site_url = `https://${process.env.REACT_APP_SITE_URL}`
  return ( 
    <>
      
      <Typography variant="body2" align="center" color="text.secondary">
        {'Copyright © '}
        <Link color="inherit" href={site_url} >
          {site_url}
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </>
  )
}

export default function StickyFooter() {
  return (
    <div className='footer-loader' style={{  boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)"}}>
      <Box
        component="footer"
        sx={{
          py: 2, px: 2,
          mt: 'auto',
          boxShadow: '1px 1px 1px #ccc',
        }}
      >
        <Container >
          {/* <MenuFooter /> */}
          <Typography variant="body1" align='center'>
            {process.env.REACT_APP_FOOTER_TITLE}
          </Typography>
          <Copyright />
        </Container> 
      </Box>
    </div>
  )
}